import Contact from '@components/contact/Contact';
import { useBuildMetaTitle, useSetGlobalAppLanguage } from '@components/Hooks';
import Layout from '@components/layout/Layout';
import config from '@config';
import AppSetting from '@xFrame4/business/AppSetting';
import CustomHead from '@xFrame4/components/next/CustomHead';
import { GetStaticProps } from 'next';
import { getCommonStaticProps } from 'pages';
import { FunctionComponent } from 'react';
import { PageWithLanguageParams, PageWithLanguageProps } from '.';
import { getStaticPaths as languageGetStaticPaths } from '.';

interface ContactPageParams extends PageWithLanguageParams
{
    
}

interface ContactPageProps extends PageWithLanguageProps
{

}

export const getStaticPaths = languageGetStaticPaths;

export const getStaticProps: GetStaticProps<ContactPageProps, ContactPageParams> = async (context) => 
{
    // language
    let language = config.languages.find(l => l.code == context.params?.language);
    if (language === undefined) language = config.defaultLanguage;
    
    // Common page props
    let commonPageProps = await getCommonStaticProps();

    return {
        props: {
           ...commonPageProps,
           language: language
        }
    };
}

const ContactPage: FunctionComponent<ContactPageProps> = (props) =>
{
    useSetGlobalAppLanguage(props.language);
    
    /** Meta */
    let metaTitle = useBuildMetaTitle('CONTACT');

    /** Render */
    return (
        <>
            <CustomHead 
                metaData={{
                    title: metaTitle
                }}
            />

            <Layout 
                menuItems={props.menuItems}
                appSettings={AppSetting.createArrayFromJson(props.appSettings) as AppSetting[]}
            >
                <Contact 
                    appSettings={AppSetting.createArrayFromJson(props.appSettings) as AppSetting[]}
                />
            </Layout>
        </>
    );
}

export default ContactPage;